import React from "react";
import "./SaveSection.css";
import Savesection from "../../assets/Savesection.png";
import { Link } from "react-router-dom";

const SaveSection = () => {
  return (
    <section className="save-section">
      <p className="save-section-subtitle">A WORLD WIDE DISTRIBUTOR OF SOLAR SUPPLIES</p>
      <h2 className="save-section-title">Let's see how much you save</h2>

      <div className="save-section-content">
        {/* LEFT TEXT BLOCK */}
        <div className="save-section-text">
          <h3>We are building a sustainable absolute green future.</h3>
          <p>
            Powering India’s transition to a sustainable future. 
            We deliver high-performance, reliable solar systems 
            that drastically reduce energy costs and environmental 
            footprint for homes, businesses, and industries nationwide.
            Join the movement to energy independence.
          </p>

          <Link to="/green-energy/services" className="save-section-btn">
  View services →
</Link>
        </div>

        {/* IMAGE BLOCK */}
        <div className="save-section-image-wrapper">
          <img
            src={Savesection}
            alt="Solar panels"
            className="save-section-image"
          />
          <div className="save-section-badge"><span style={{ fontSize: "25px", fontWeight: "700",}}>50%</span>
  Renewable energy growth</div>
        </div>

        {/* RIGHT SIDE STATS */}
        <div className="save-section-stats">
          <p>Projects completed in last 3 years.</p>
          <p>Happy customers who trusted us.</p>
          <p>Awards milestones awarded to us.</p>
        </div>
      </div>

      {/* BIG BACKGROUND TEXT */}
      <h1 className="background-text">Green Energy</h1>
    </section>
  );
};

export default SaveSection;
